import { render, staticRenderFns } from "./ModalCatalogProduct.vue?vue&type=template&id=2f1a2582&scoped=true&"
import script from "./ModalCatalogProduct.vue?vue&type=script&lang=js&"
export * from "./ModalCatalogProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1a2582",
  null
  
)

export default component.exports